import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { Button, ThemeStyle } from '@treelab/panda';

import { GLYPHS } from '../../../../../constants/icons';

import { IDispatch } from '../../../../../modules/stores';

import { BtnMixin } from './styled';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends WrappedComponentProps {
  // Edge case for remove template, it will pass in a function.
  removeTemplate?: () => void;
}

const DeleteBtn: React.FC<IProps & IConnectProps> = ({
  removeSpace,
  removeTemplate,
  intl: { formatMessage },
}) => (
  <Button
    buttonType="text"
    onClick={() => {
      removeTemplate ? removeTemplate() : removeSpace();
    }}
    css={BtnMixin}
    icon={GLYPHS.TRASH_CAN}
    iconSize={{ height: 14, width: 14 }}
    colorTheme={ThemeStyle.white}
  >
    {formatMessage({ id: 'sidebar.button.remove' })}
  </Button>
);

const mapDispatch = ({ space }: IDispatch) => ({
  removeSpace: space.removeSpace,
});

export default compose(
  injectIntl,
  connect(
    () => ({}),
    // @ts-ignore
    mapDispatch,
  ),
)(DeleteBtn);
